import { useEffect, useRef } from 'react'

type UseInViewOptions = {
  enabled?: boolean
  onEnter: () => void
}

export function useInView<T extends Element>({ enabled = true, onEnter }: UseInViewOptions) {
  const ref = useRef<T>(null)

  // keeps the latest callback without re-subscribing the observer
  const onEnterRef = useRef(onEnter)
  onEnterRef.current = onEnter

  useEffect(() => {
    if (!enabled || typeof IntersectionObserver === 'undefined') return

    const node = ref.current
    if (!node) return

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) onEnterRef.current()
    })
    observer.observe(node)

    return () => observer.disconnect()
  }, [enabled])

  return ref
}
